import axios from 'axios';
import getAPIResponsePrivate from 'Shared/Utils/Domain/Services/GetAPIResponsePrivateService';

export const CorporateDocumentService = {
  // User endpoints
  getTree: async () => {
    return await getAPIResponsePrivate('/v1/corporate-documents/tree', {}, 'GET');
  },

  sendPetition: async (message) => {
    return await getAPIResponsePrivate('/v1/corporate-documents/petition', { message }, 'POST');
  },

  getDocumentFileUrl: (id, isDownload = false) => {
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '/api';
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);
    const params = new URLSearchParams();
    if (isDownload) {
      params.set('download', '1');
    }
    if (token) {
      params.set('bearer', token);
    }
    const queryString = params.toString();
    return `${backendUrl}/v1/corporate-documents/${id}/file${queryString ? `?${queryString}` : ''}`;
  },

  // Admin endpoints
  getAdminCategories: async () => {
    return await getAPIResponsePrivate('/v1/admin/corporate-documents/categories', {}, 'GET');
  },

  createCategory: async (data) => {
    return await getAPIResponsePrivate('/v1/admin/corporate-documents/categories', data, 'POST');
  },

  updateCategory: async (id, data) => {
    return await getAPIResponsePrivate(`/v1/admin/corporate-documents/categories/${id}`, data, 'PUT');
  },

  deleteCategory: async (id) => {
    return await getAPIResponsePrivate(`/v1/admin/corporate-documents/categories/${id}`, {}, 'DELETE');
  },

  uploadDocument: async (file, name, categoryId) => {
    const formData = new FormData();
    formData.append('file', file);
    if (name) {
      formData.append('name', name);
    }
    formData.append('categoryId', categoryId);

    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);
    const backendUrl = process.env.REACT_APP_BACKEND_URL || '/api';
    const response = await axios.post(
      `${backendUrl}/v1/admin/corporate-documents/upload`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  },

  updateDocument: async (id, data) => {
    return await getAPIResponsePrivate(`/v1/admin/corporate-documents/${id}`, data, 'PUT');
  },

  deleteDocument: async (id) => {
    return await getAPIResponsePrivate(`/v1/admin/corporate-documents/${id}`, {}, 'DELETE');
  },
};
